class Export {
  constructor({
    id,
    targetOrg,
    type,
    format,
    status,
    statusReason,
    createdAt,
    updatedAt,
    completedAt,
    createdBy,
    isHidden,
    isInitiatedByUser,
    fileDisplayNames,
  } = {}) {
    this.id = id;
    this.targetOrg = targetOrg;
    this.type = type;
    this.format = format;
    this.status = status;
    this.statusReason = statusReason;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.completedAt = completedAt;
    this.createdBy = createdBy;
    this.isHidden = isHidden;
    this.isInitiatedByUser = isInitiatedByUser;
    this.fileDisplayNames = fileDisplayNames;
  }

  static fromServerModel(data = {}) {
    return new Export({
      id: data.id,
      targetOrg: data.targetOrg,
      type: data.type,
      format: data.format,
      status: data.status,
      statusReason: data.statusReason,
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
      completedAt: data.completedAt,
      createdBy: data.createdBy,
      isHidden: data.isHidden,
      isInitiatedByUser: data.isInitiatedByUser,
      fileDisplayNames: data.fileDisplayNames,
    });
  }

  toServerModel() {
    return {
      id: this.id,
      targetOrg: this.targetOrg,
      type: this.type,
      format: this.format,
      status: this.status,
      statusReason: this.statusReason,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      completedAt: this.completedAt,
      createdBy: this.createdBy,
      isHidden: this.isHidden,
      isInitiatedByUser: this.isInitiatedByUser,
      fileDisplayNames: this.fileDisplayNames,
    };
  }
}

export default Export;
